// extracted by mini-css-extract-plugin
export default {"newman_prize_background":"NewmanPrize_newman_prize_background__6-Dm+"};